var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-100"},[_c('div',{staticClass:"logo-brand",class:("" + (_vm.formModal.logoImg.url ? 'preview-image bg-transparent' : null)),style:(_vm.formModal.logoImg.url
          ? ("background-image : url(" + (_vm.formModal.logoImg.url) + ")")
          : ("background-image : url(" + _vm.NoImageIcon + ")"))})])])}
var staticRenderFns = []

export { render, staticRenderFns }